import * as Types from '../constants/actionTypes';
const defaultState = {
    culturesList: [],

}
export const culturesRender = (state = defaultState, action) => {
    switch (action.type) {
        case Types.CULTURES_DETAIL_SUCCESS:
            return {
                ...state,
                culturesList: action.payload
            }
        case Types.CULTURES_DETAIL_ERROR:
            return {
                ...state,
                cultureDetailError: action.cultureDetailError
            }
        /* Cultures List  */
        case Types.LIST_CULTURES_LIST:
            return {
                ...state,
                allCultures: action.allCultures
            }
        case Types.CULTURES_ADDED_SUCCESS: 
            state.culturesList.push(action.payload)
            return {
                ...state,
                addStatus: action.payload && action.payload.id
            }
        
        //Delete Function 
        case Types.CULTURES_DELETED_SUCCESS:
            const newList = state.culturesList.filter((culture) => culture.id !== action.payload )
            return {
                ...state,
                culturesList : newList,
                deletedStatus:action.payload
            }
        //Update Function 
        case Types.UPDATED_CULTURES_DATA:
                const existCulturesList = state.culturesList;
                existCulturesList[action.updateIndex] = action.updatedCultures
                return {
                    ...state,
                    culturesList: existCulturesList
                }
        case Types.CULTURE_INFO_COUNT_SUCCESS:
               return Object.assign({}, state, { languageInfoCount: action.payload})
        default:
            return state
    }
}


// export const culturesAddRender = (state = { isPending: false, status: "", error: '' }, action) => {
//     switch (action.type) {
        
//         default:
//             return state
//     }
// }



// export const culturesDeleteRender = (state = { isPending: false, status: "", error: '' }, action) => {
//     switch (action.type) {
        
//         default:
//             return state
//     }
// }